<template>
  <b-modal
    id="makeTransactionModal"
    ref="modal"
    title="Realizar traslado"
    size="xl"
    hide-footer
    no-close-on-esc
    lazy
  >
    <b-tabs lazy>
      <b-tab title="Efectivo">
        <div class="m-3">
          <MakeEfectivoTransaction></MakeEfectivoTransaction>
        </div>
      </b-tab>
      <b-tab title="Cheques">
        <div class="m-3">
          <MakeChequesTransaction></MakeChequesTransaction>
        </div>
      </b-tab>
    </b-tabs>
  </b-modal>
</template>

<script>
import { BTab, BTabs } from "bootstrap-vue";
import MakeEfectivoTransaction from "./MakeEfectivoTransaction.vue";
import MakeChequesTransaction from "./MakeChequesTransaction.vue";

export default {
  name: "MakeTransaction",
  components: { BTabs, BTab, MakeEfectivoTransaction, MakeChequesTransaction },
};
</script>

<style scoped></style>
